export default {
	GET_ALL: (crewId) => `/houseTask/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseTask?crewId=${crewId}`,
	UPDATE: (id) => `/houseTask/${id}`,
	UPDATE_COMPLETE: (id) => `/houseTask/${id}/complete`,
	DELETE: (id) => `/houseTask/${id}`,
};
